import axios from 'axios';

export const loadConfig = async () => {
  try {
    const response = await axios.get('/config.json');
    return response.data.development;
  } catch (error) {
    console.error('Error loading config:', error);
    return null;
  }
};
